import axios from 'axios'
import { ensureCsrfToken } from '../../../lib/csrf'

const url = program => `/api/digital-risk/portfolio-reassessments/programs/${encodeURIComponent(program)}/`
export const readCreation = async (program, operation) => (await axios.get(
    `${url(program)}creation-operations/${encodeURIComponent(operation)}/`, { withCredentials: true, timeout: 30000 })).data
export const readReassessments = async program => (await axios.get(url(program), { withCredentials: true, timeout: 30000 })).data
export const createPortfolioReassessment = ({ programReference, operationId, payload, ready, onSending }) =>
    sendCreation(programReference, operationId, payload, { ready, onSending })
export const sendCreation = async (program, operation, payload, { ready, onSending }) => {
    let token
    try {
        if (!operation || typeof onSending !== 'function') throw new Error()
        if (!await ready()) throw new Error()
        token = await ensureCsrfToken()
        if (!await ready() || !ready.isCurrent()) throw new Error()
        // Durable marker must succeed before transport. No await after this fence.
        onSending()
    } catch {
        throw Object.assign(new Error('Creation was not sent. Review your session or browser storage before a new deliberate attempt.'), { notSent: true })
    }
    return (await axios.post(url(program), payload, { withCredentials: true, timeout: 30000,
        headers: { 'X-CSRFToken': token, 'Idempotency-Key': operation } })).data
}
